import React, { Component } from 'react';
import { connect } from 'react-redux'
import moment from 'moment'

import InventoryRefreshComponent from '../../components/inventoryRefresh';

import * as actions from './actions'
import { opdbGTM } from '../../utils/pulseUtils';

class InventoryRefreshContainer extends Component{
    constructor(props){
        super(props);
        this.state = {
            source: null,
            destination: null,
            journeyDate: null,
            focusedJourneyDate: false,
            currentDate: moment().format('DD-MMM-YYYY'),
            inventoryRefreshCheckbox: false
        }
    }
    componentDidMount() {
        opdbGTM.tabClicked('od_inventory_refresh_tab_clicked');
    }
    onSourceItemSelect = (item) => {
        this.setState({ source: item })
    }
    onDestinationItemSelect = (item) => {
        this.setState({ destination: item })
    }
    fetchCities = (value, fieldType) => {
        this.props.fetchCities(value, fieldType);
    }
    onSearchClick = () => {
        const { source, destination, journeyDate, inventoryRefreshCheckbox } = this.state;
        if(!source || !destination) {
          alert('Please select a valid value of source and destination.');
          return;
        }
        this.props.inventoryRefresh({
            source_id: source.city_id.toString(),
            destination_id: destination.city_id.toString(),
            date: journeyDate? journeyDate.format('YYYY-MM-DD'): undefined,
            via_routes_support: inventoryRefreshCheckbox
        });
        opdbGTM.refreshSubmitClicked(source, destination, journeyDate, inventoryRefreshCheckbox);
      }

    onJourneyDateChange = date => this.setState({ journeyDate: date })

    onJourneyDateFocusChange = ({ focused }) => this.setState({ focusedJourneyDate: focused })

    journeyDateRangeChecker = (date) => moment().diff(date) > 0

    onInventoryRefreshCheckBOx = () => this.setState({ inventoryRefreshCheckbox: !this.state.inventoryRefreshCheckbox })

    render(){
        return(
            <div>
                <InventoryRefreshComponent
                    onSourceItemSelect={this.onSourceItemSelect}
                    onDestinationItemSelect={this.onDestinationItemSelect}
                    sourceCityData={this.props.sourceCityData}
                    destCityData={this.props.destCityData}
                    routeServices={this.props.routeServices}
                    fetchCities={this.fetchCities}
                    onSearchClick={this.onSearchClick}
                    journeyDate={this.state.journeyDate}
                    onJourneyDateChange={this.onJourneyDateChange}
                    focusedJourneyDate={this.state.focusedJourneyDate}
                    onJourneyDateFocusChange={this.onJourneyDateFocusChange}
                    journeyDateRangeChecker={this.journeyDateRangeChecker}
                    inventoryRefreshCheckbox={this.state.inventoryRefreshCheckbox}
                    onInventoryRefreshCheckBOx={this.onInventoryRefreshCheckBOx}
                />
            </div>
        )
    }
}

const mapStateToProps = store => ({
    sourceCityData: store.inventoryRefreshReducer.sourceCityData,
    destCityData: store.inventoryRefreshReducer.destCityData,
    allRoutesInfo: store.userInfoReducer.allRoutesInfo,
  })

const mapDispatchToProps = dispatch => ({
    inventoryRefresh: (query) => dispatch(actions.inventoryRefresh(query)),
    fetchCities: (queryStr, fieldType) => dispatch(actions.fetchCities(queryStr, fieldType)),
})

  export default connect(mapStateToProps, mapDispatchToProps)(InventoryRefreshContainer)
